export const isTotalRowClassName = (className: string): boolean => {
  // Subtotal rows should keep zebra striping so grouped detail blocks stay visually connected.
  if (className.includes('subtotal')) {
    return false;
  }

  // Sheet configs mark grand totals with `__total` or `*-total`.
  if (className.includes('__total')) {
    return true;
  }

  return className.split(/\s+/).some(token => token.endsWith('-total'));
};
